<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closePage()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/x.svg'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ capacitor.translateString('Invites') }}</ion-title>
    <ion-buttons slot="primary" end>
      <ion-button (click)="openTour()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/message-question-circle.svg'"></ion-icon>
        <ion-label>{{ capacitor.translateString('Help') }}</ion-label>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- Invite -->

  <ion-grid>
    <ion-list class="padding">
      <div class="info">
        <div class="text">{{ capacitor.translateString('InviteTour') }}</div>
        <button class="cta medium transparent outline invites" (click)="openPremium()">
          <ion-icon [src]="'/assets/icons/dark/users-check.svg'"></ion-icon>
          <ion-spinner *ngIf="!data"></ion-spinner>
          <span *ngIf="data && !data?.premium">
            {{ data?.limits?.invites?.count }}/{{ data?.limits?.invites?.premium }}
            ({{ capacitor.translateString('PremiumFree') }})
          </span>
          <span *ngIf="data && data?.premium">
            {{ data?.limits?.invites?.count }}/∞
            ({{ capacitor.translateString('Premium') }})
          </span>
        </button>
        <button class="cta medium white invites" (click)="openPremium()" *ngIf="data && !data?.premium">
          {{ capacitor.translateString('PremiumGo') }}
        </button>
      </div>
      <div class="error" *ngIf="data && !data?.premium && data?.limits?.invites?.maximum">{{ capacitor.translateString('InviteUpgrade') }}</div>
    </ion-list>
  </ion-grid>

  <!-- Received -->

  <ion-grid *ngIf="invites?.received?.length != 0">
    <app-header title="Received"></app-header>
    <ion-list>
      <ion-skeleton-text class="list" [animated]="true" *ngIf="!data"></ion-skeleton-text>
      <app-item [data]="invite" class="box" *ngFor="let invite of invites?.received"></app-item>
    </ion-list>
  </ion-grid>

  <!-- Lists -->

  <ion-grid>
    <app-header title="Lists" [tour]="true"></app-header>
    <ion-list>
      <ion-skeleton-text class="list" [animated]="true" *ngIf="!data"></ion-skeleton-text>
      <div class="empty" *ngIf="invites?.lists?.length == 0">{{ capacitor.translateString('ListsEmpty') }}</div>
      <app-item [data]="invite" class="box" *ngFor="let invite of invites?.lists"></app-item>
    </ion-list>
  </ion-grid>

  <!-- Pending -->

  <ion-grid *ngIf="invites?.pending?.length != 0">
    <app-header title="Pending"></app-header>
    <ion-list>
      <ion-skeleton-text class="list" [animated]="true" *ngIf="!data"></ion-skeleton-text>
      <app-item [data]="invite" *ngFor="let invite of invites?.pending"></app-item>
    </ion-list>
  </ion-grid>

  <!-- Accepted -->

  <ion-grid *ngIf="invites?.accepted?.length != 0">
    <app-header title="Accepted"></app-header>
    <ion-list>
      <ion-skeleton-text class="list" [animated]="true" *ngIf="!data"></ion-skeleton-text>
      <app-item [data]="invite" *ngFor="let invite of invites?.accepted"></app-item>
    </ion-list>
  </ion-grid>

</ion-content>